import React, { Component } from "react";
import { Link } from "react-router";
import appicon from "../../../assets/images/asepsis-logo.png";
import { getRequest } from "../../../utils/apiUtils";
import "./style.css";

var axios = require("axios");

class SiteHead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLogout: false,
      user_name: "",
      role_name: "",
    };
    this.userSectionRef = null;
    this.setUserSectionRef = element => {
      this.userSectionRef = element;
    };
  }

  componentDidMount() {
    var that = this;
    getRequest({ url: "api/get_user_data" })
      .then(function (response) {
        if (response.data != "") {
          // Handle both array and object response formats
          const userData = Array.isArray(response.data) ? response.data[0] : response.data;
          that.setState({
            user_name: userData.first_name || userData.user_name,
            role_name: userData.role_name,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.userSectionRef && !this.userSectionRef.contains(event.target)) {
      this.setState({ showLogout: false });
    }
  };

  toggleLogout = () => {
    this.setState((prevState) => ({
      showLogout: !prevState.showLogout,
    }));
  };

  logout = () => {
    axios
      .get("/api/logout")
      .then(function (response) {
        window.location.href = "/";
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 403) {
            window.location.href = "/";
          } else {
            console.log(error);
          }
        } else {
          console.log(error);
        }
      });
  };

  render() {
    const currentDate = new Date().toLocaleDateString("en-US", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

    return (
      <header className="site-head">
        {/* LEFT: Branding */}
        <div className="header-branding">
          <div className="brand-logo-wrapper">
            <Link to="/dashboard">
              <img src={appicon} alt="ASEPSIS Logo" className="logo-image" />
            </Link>
          </div>
        </div>

        {/* RIGHT: User Profile */}
        <div className="right-elems">
          <div className="wrap profile" ref={this.setUserSectionRef}>
            <div className={`dropdown ${this.state.showLogout ? 'show' : ''}`}>
              {/* User Chip (Clickable) */}
              <div 
                className="user-chip" 
                onClick={this.toggleLogout}
                aria-haspopup="true"
                aria-expanded={this.state.showLogout}
              >
                <img src="/icon.jpg" alt="avatar" className="user-avatar" />
                <div>
                  <div className="user-date">{currentDate}</div>
                  <div className="welcome-text">Welcome, {this.state.user_name}</div>
                </div>
              </div>

              {/* Dropdown Menu */}
              {this.state.showLogout && (
                <div 
                  className="user-dropdown-menu dropdown-menu dropdown-menu-right show"
                  role="menu"
                  aria-hidden="false"
                >
                  <div className="logout-wrapper">
                    <Link to="/">
                      <button className="logout-btn btn btn-secondary btn-block" onClick={this.logout}>
                        <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" height="16" width="16" viewBox="0 0 40 40" style={{verticalAlign: 'middle'}}>
                          <g>
                            <path d="m29.7 8.6q5.3 4.5 5.3 11.4 0 6.3-4.4 10.6t-10.6 4.4-10.6-4.4-4.4-10.6q0-6.9 5.3-11.4l2.4 2.3q-4.3 3.6-4.3 9.1 0 4.8 3.4 8.2t8.2 3.4 8.2-3.4 3.4-8.2q0-5.5-4.3-9z m-8.1-3.6v16.6h-3.2v-16.6h3.2z"></path>
                          </g>
                        </svg>
                        <span>Logout</span>
                      </button>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default SiteHead;



// WEBPACK FOOTER //
// ./src/shared/components/header/index.js